export const validateOrderForm = (customerName, contactNumber, order) => {
  const errors = [];
  
  if (!customerName?.trim()) {
    errors.push("Customer name is required");
  }
  
  // Contact number is optional, but if provided, it must be 10 digits
  if (contactNumber?.trim() && !/^\d{10}$/.test(contactNumber.trim())) {
    errors.push("Contact number must be 10 digits");
  }
  
  if (!order?.length) {
    errors.push("Please add at least one item to your order");
  }
  
  return {
    isValid: errors.length === 0,
    errors
  };
};

export const validateContactNumber = (contactNumber) => {
  // Contact number is optional, but if provided, it must be 10 digits
  if (contactNumber?.trim() && !/^\d{10}$/.test(contactNumber.trim())) {
    return { isValid: false, error: "Contact number must be 10 digits" };
  }
  
  return { isValid: true, error: null };
};